<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
    <div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border shadow-lg border-zinc-950/10 dark:border-white/10">
        <form [formGroup]="addTicketForm" (ngSubmit)="onSave()">
            <h1 class="heading">Add Ticket</h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="grid gap-4 md:grid-cols-2">

                <!-- Raise for: broker staff pick the tenant the ticket is for -->
                <div *ngIf="isBrokerStaff" class="space-y-1 md:col-span-2">
                    <app-support-contact-picker typeLabel="Raise For" [required]="true" [invalid]="submitted && !selectedContact"
                        (selectContact)="onSelectContact($event)"></app-support-contact-picker>
                    <div *ngIf="submitted && !selectedContact">
                        <p class="mt-2 text-red-600 text-xs">Raise for is required</p>
                    </div>
                </div>

                <!-- Regarding: general, billing, or a trip, company, vehicle or driver -->
                <div *ngIf="regardingOptions.length" class="space-y-1 md:col-span-2">
                    <app-support-contact-picker [types]="regardingOptions" typeLabel="Regarding" [scope]="selectedContact"
                        [required]="true" [invalid]="submitted && isReferenceMissing"
                        (selectType)="onSelectRegarding($event)" (selectContact)="setReference($event)"></app-support-contact-picker>
                    <div *ngIf="submitted && isReferenceMissing">
                        <p class="mt-2 text-red-600 text-xs">Select the {{(regarding.recordLabel || regarding.label) | lowercase}} the ticket is about</p>
                    </div>
                </div>

                <!-- Subject -->
                <div class="space-y-1">
                    <label class="subheading">
                        Subject <span *ngIf="!reference" class="text-red-600">*</span>
                    </label>
                    <input type="text" formControlName="subject"
                        [placeholder]="reference ? 'Generated from the reference when left empty' : ''" />
                    <div *ngIf="form.subject.errors && submitted">
                        <div *ngIf="form.subject.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">Subject is required</p>
                        </div>
                    </div>
                </div>

                <!-- Priority -->
                <div class="space-y-1">
                    <label class="subheading">
                        Priority <span class="text-red-600">*</span>
                    </label>
                    <select formControlName="priority">
                        <option *ngFor="let priority of priorityOptions" [value]="priority.value">{{priority.label}}</option>
                    </select>
                    <div *ngIf="form.priority.errors && submitted">
                        <div *ngIf="form.priority.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">Priority is required</p>
                        </div>
                    </div>
                </div>

                <!-- Description -->
                <div class="space-y-1 md:col-span-2">
                    <label class="subheading">Description</label>
                    <textarea rows="4" formControlName="description"></textarea>
                </div>

                <!-- Attachments -->
                <div class="space-y-1 md:col-span-2">
                    <label class="subheading">Attachments</label>
                    <div class="flex flex-wrap items-center gap-2">
                        <span *ngFor="let attachment of attachments; let i = index" class="badge-secondary flex items-center gap-1">
                            {{attachment.name}}
                            <button type="button" (click)="removeAttachment(i)" title="Remove">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </span>
                        <label class="btn btn-outline-secondary cursor-pointer">
                            <input type="file" multiple class="hidden" (change)="onSelectFiles($event)" [disabled]="isUploading" />
                            {{isUploading ? 'Uploading...' : 'Attach files'}}
                        </label>
                    </div>
                </div>
            </section>

            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="flex justify-end gap-4">
                <button type="button" routerLink="/support/tickets" class="btn-outline btn-outline-secondary">Cancel</button>
                <button type="submit" class="btn btn-secondary" [disabled]="isUploading || isSaving">
                    {{isSaving ? 'Creating...' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</section>
